import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HistoryItem, HistoryItemType } from '../../../models/history-user';
import { BaseData } from '../../card-item/models/base-data.model';
import { CardItemCover, CardItemProgress } from '../../../_shared/components/card-item/card-item.interface';
import { HistoryButtonConfiguration } from '../../../models/buttons-config';

@Component({
  selector: 'app-user-history-item',
  templateUrl: './user-history-item.component.html',
  styleUrls: ['./user-history-item.component.scss'],
})
export class UserHistoryItemComponent implements OnInit {
  @Input()
  historyItem: HistoryItem;

  @Output()
  removed = new EventEmitter<HistoryItem>();

  readonly config = new HistoryButtonConfiguration();

  coverDetails?: CardItemCover = undefined;
  progressDetails?: CardItemProgress = undefined;
  showRecordButtons: boolean;
  baseData: BaseData;

  ngOnInit() {
    this.showRecordButtons = this.historyItem.type !== HistoryItemType.VISUALIZATION;
    this.buildBaseData();
  }

  onRemoved(item: HistoryItem) {
    this.removed.emit(item);
  }

  private buildBaseData() {
    this.baseData = {
      record: this.historyItem.record,
      author: this.historyItem.record.author,
      title: this.historyItem.record.title,
      cover: this.historyItem.record.coverImageUrl,
      icon: this.historyItem.record.icon,
    };
    this.coverDetails = {
      url: this.historyItem.record.coverImageUrl,
      icon: this.historyItem.record.icon,
      isList: Boolean(this.historyItem.record.wishListInfo),
    };

    if (this.historyItem.percentage > 0) {
      this.progressDetails = {
        percentage: this.historyItem.percentage
      }
    }
  }
}
